import React, { useState } from "react";
import { SIZE_TABLE, convertFromMm, convertFromDn, convertFromInch } from "../lib/conversions";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";

export default function ConversionPage() {
  const [mm, setMm] = useState("");
  const [dn, setDn] = useState("");
  const [inch, setInch] = useState("");

  const updateFromMm = (v) => {
    setMm(v);
    if (v === "") { setDn(""); setInch(""); return; }
    const c = convertFromMm(parseFloat(v));
    if (c) { setDn(String(c.dn)); setInch(c.inch); }
  };
  const updateFromDn = (v) => {
    setDn(v);
    if (v === "") { setMm(""); setInch(""); return; }
    const c = convertFromDn(v);
    if (c) { setMm(String(c.d1_mm)); setInch(c.inch); }
  };
  const updateFromInch = (v) => {
    setInch(v);
    if (v === "") { setMm(""); setDn(""); return; }
    const c = convertFromInch(v);
    if (c) { setMm(String(c.d1_mm)); setDn(String(c.dn)); }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="conversion-page">
      <div className="bg-nibro-sage-pale py-12">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
          <div className="nibro-frame">
            <h1 className="nibro-section-title">DN · INCH · MM CONVERSIE</h1>
            <p className="mt-3 text-center text-sm text-zinc-600">
              Eén bron van waarheid — voer een waarde in, zie alle drie eenheden direct.
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 py-10 lg:px-10">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <ConvCard label="D1 (mm)" value={mm} setValue={updateFromMm} placeholder="33.7" testId="conv-mm" />
          <ConvCard label="DN" value={dn} setValue={updateFromDn} placeholder="25" testId="conv-dn" />
          <ConvCard label="Inch" value={inch} setValue={updateFromInch} placeholder='1"' testId="conv-inch" />
        </div>

        {mm && (
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to={`/products?d1_mm=${mm}`}
              className="inline-flex items-center gap-2 rounded-md bg-nibro-sage px-5 py-2.5 text-sm font-bold text-white transition hover:bg-nibro-sage-hover"
              data-testid="conv-show-products"
            >
              <Search size={14} /> Vind compatibele producten <ArrowRight size={14} />
            </Link>
          </div>
        )}

        <div className="mt-12">
          <div className="label-uppercase mb-3">Volledige maattabel</div>
          <div className="overflow-hidden rounded-md border-2 border-nibro-sage">
            <table className="w-full text-sm" data-testid="conversion-table">
              <thead style={{ backgroundColor: "var(--nibro-sage)" }}>
                <tr className="text-left text-white">
                  <Th>DN</Th>
                  <Th>Inch</Th>
                  <Th>D1 (mm)</Th>
                  <Th align="right">Producten</Th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {SIZE_TABLE.map((s, idx) => (
                  <tr key={s.dn} className={`border-t border-zinc-100 hover:bg-nibro-sage-pale ${idx % 2 === 1 ? "bg-zinc-50/50" : ""}`}>
                    <Td><span className="font-mono font-bold">DN{s.dn}</span></Td>
                    <Td><span className="font-mono">{s.inch}</span></Td>
                    <Td><span className="font-mono">{s.d1_mm}</span></Td>
                    <Td align="right">
                      <Link to={`/dn/${s.dn}`} className="font-mono text-xs font-bold uppercase tracking-wider text-nibro-sage-dark hover:underline">
                        Bekijk →
                      </Link>
                    </Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function ConvCard({ label, value, setValue, placeholder, testId }) {
  return (
    <div className="rounded-md border-2 border-nibro-sage bg-white p-5">
      <div className="label-uppercase mb-3">{label}</div>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-md border border-zinc-200 bg-white px-3 py-3 font-display text-2xl font-bold focus:border-nibro-sage focus:outline-none focus:ring-2 focus:ring-nibro-sage/30"
        data-testid={testId}
      />
    </div>
  );
}
function Th({ children, align = "left" }) {
  return <th className={`px-4 py-3 font-mono text-[11px] uppercase tracking-wider text-${align}`}>{children}</th>;
}
function Td({ children, align = "left" }) {
  return <td className={`px-4 py-3 text-${align} text-zinc-800`}>{children}</td>;
}
